var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M940 4984 c-43 -19 -68 -41 -87 -78 -19 -36 -20 -114 -3 -147 30 -56 243 -338 268 -355 42 -28 120 -30 169 -5 74 37 112 138 80 211 -8 19 -66 105 -129 190 -93 127 -121 159 -158 178 -51 26 -91 27 -140 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4040 4978 c-37 -19 -66 -51 -167 -191 -76 -105 -125 -181 -129 -203 -21 -114 65 -212 180 -202 28 2 63 12 78 22 25 17 238 299 268 355 17 33 16 111 -3 147 -20 38 -44 60 -90 79 -50 21 -85 19 -137 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2445 4717 c-69 -23 -118 -54 -168 -104 -40 -41 -80 -114 -251 -459 l-203 -409 -374 -54 c-498 -71 -532 -77 -590 -107 -146 -73 -228 -219 -216 -385 10 -146 14 -151 392 -524 l336 -330 -76 -437 c-41 -240 -75 -454 -75 -475 0 -60 28 -153 61 -205 89 -138 263 -212 419 -179 36 8 188 82 449 219 217 114 400 208 406 210 6 1 191 -92 411 -207 275 -145 416 -214 454 -222 239 -50 478 141 480 384 0 21 -34 235 -75 475 l-76 437 336 330 c380 375 383 378 392 530 10 162 -72 306 -217 380 -58 29 -99 37 -589 107 l-374 53 -204 410 c-178 359 -210 416 -255 462 -74 75 -149 106 -263 110 -56 2 -105 -2 -130 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 2185 c-205 -67 -239 -87 -267 -152 -45 -104 38 -232 150 -233 44 0 372 102 429 133 92 51 111 179 39 261 -24 26 -91 56 -127 55 -16 -1 -117 -29 -224 -64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4545 2231 c-22 -10 -48 -27 -57 -37 -24 -27 -48 -88 -48 -121 0 -48 38 -111 83 -137 58 -32 387 -136 433 -136 55 0 118 41 143 93 35 73 25 136 -32 195 -27 28 -62 43 -232 97 -111 36 -212 65 -225 65 -14 0 -43 -9 -65 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2506 800 c-16 -5 -42 -22 -59 -37 -53 -50 -57 -73 -57 -300 0 -186 2 -211 20 -247 56 -115 218 -126 290 -19 24 36 25 41 28 247 2 127 -1 225 -7 246 -18 62 -101 122 -165 119 -12 0 -34 -5 -50 -9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.150dbd1004f71dd9ece33e1c72cbbe50.svg";
export { ForwardRef as ReactComponent };